import { Component } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Observable } from 'rxjs';
import { Toast, ToastService } from '../../service/toast/toast.service';

/**
 * Renders the ToastService queue at the bottom of the viewport (above the
 * mobile bottom nav). One instance lives in the landing layout.
 */
@Component( {
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: [ './toast.component.scss' ],
  animations: [
    trigger( 'toastIn', [
      transition( ':enter', [
        style( { opacity: 0, transform: 'translateY(-10px)' } ),
        animate( '220ms cubic-bezier(0.22, 1, 0.36, 1)', style( { opacity: 1, transform: 'translateY(0)' } ) ),
      ] ),
      transition( ':leave', [
        animate( '160ms ease-in', style( { opacity: 0, transform: 'translateY(-6px)' } ) ),
      ] ),
    ] ),
  ],
} )
export class ToastComponent {

  toasts$: Observable<Toast[]>;

  constructor( private toastService: ToastService ) {
    this.toasts$ = this.toastService.toasts$;
  }

  act( toast: Toast ): void {
    this.toastService.act( toast );
  }

  dismiss( toast: Toast ): void {
    this.toastService.dismiss( toast.id );
  }

  trackById( index: number, toast: Toast ): number {
    return toast.id;
  }
}
